import { PARTNER_AIRBNB_COLUMN_MAPPING } from '../components/partner/airbnb/constants';

export default {
    namespaced: true,
    state() {
        return {
            columnVisibilityMapping: Object.keys(PARTNER_AIRBNB_COLUMN_MAPPING)
                .reduce(
                    (mapping, column) => {
                        mapping[column] = true;
                        return mapping;
                    }, {}
                )
        };
    },
    getters: {
        columnVisibilityMapping: state => state.columnVisibilityMapping,
    },
    mutations: {
        showColumn(state, column) {
            state.columnVisibilityMapping = {
                ...state.columnVisibilityMapping,
                [column]: true,
            }
        },
        hideColumn(state, column) {
            state.columnVisibilityMapping = {
                ...state.columnVisibilityMapping,
                [column]: false,
            }
        }
    }
}